import { Component, Input } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';

@Component({
    selector: 'app-hotkey-tooltip[keys]',
    templateUrl: './hotkey-tooltip.component.html',
	imports: [SHARED_MODULES],
    standalone: true
})
export class HotkeyTooltipComponent {

	public alternativeKeys: Array<string>;
	public keys: Array<string>;
	public secondKeys: Array<string>;

	@Input() label: string;

	@Input('alternativeKeys') set setAlternativeKeys(value: Array<string>) {
		this.alternativeKeys = value.map((key: string) => {
			if (key.toLowerCase() === 'meta') {
				return navigator.platform === 'MacIntel' ? 'Command' : 'Ctrl';
			}
			return key;
		});
	}

	@Input('keys') set setKeys(value: Array<string>) {
		this.keys = value.map((key: string) => {
			if (key.toLowerCase() === 'meta') {
				return navigator.platform === 'MacIntel' ? 'Command' : 'Ctrl';
			}
			return key;
		});
	}

	@Input('secondKeys') set setSecondKeys(value: Array<string>) {
		this.secondKeys = value.map((key: string) => {
			if (key.toLowerCase() === 'meta') {
				return navigator.platform === 'MacIntel' ? 'Command' : 'Ctrl';
			}
			return key;
		});
	}

	constructor() {}
}
